import { render } from "./ExecutorsTable.vue?vue&type=template&id=50851e5c"
import script from "./ExecutorsTable.vue?vue&type=script&lang=js"
export * from "./ExecutorsTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__